import InputQuantity from './InputQuantity.vue'
export default InputQuantity



// WEBPACK FOOTER //
// ./components/InputQuantity/index.js